var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control flex-grow "},[_c('label',{staticClass:"cursor-pointer label flex flex-col"},[_c('span',{staticClass:"label-text text-center text-lg text-primary-dark"},[_vm._v(_vm._s(_vm.scale))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }